/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Menu from '../menus/Menu';
import FooterCta from './FooterCta';

import styles from '../../../styles/partials/footer.module.css';

const propTypes = {
    menu: PropTypes.arrayOf(PropTypes.shape({})),
    footerFilm: PropTypes.shape({}),
    className: PropTypes.string,
};

function Footer({ menu = null, footerFilm = null, className }) {
    const { image = null } = footerFilm || {};
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {image !== null ? <FooterCta image={image} /> : null}
            <Menu className={styles.menu} itemsClassName={styles.menuItems} items={menu || []} />
        </div>
    );
}

Footer.propTypes = propTypes;

export default Footer;
